import { render, staticRenderFns } from "./activityPageBanner.vue?vue&type=template&id=6b15c6ae"
var script = {}
import style0 from "./activityPageBanner.vue?vue&type=style&index=0&id=6b15c6ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports